import { familyMembers, familyMemberEntries } from "../utils";

export function UserFamilyMembers({
  profile,
}: {
  profile: Record<string, unknown>;
}) {
  return (
    Array.isArray(profile.familyMembers) && (
      <section className="mt-6">
        <h3 className="text-[13px] font-medium text-ink">家庭成员</h3>
        {familyMembers(profile).length ? (
          <div className="mt-3 space-y-4">
            {familyMembers(profile).map((member, index) => (
              <div
                key={index}
                className="rounded-xl border border-sand-light/70 p-4"
              >
                <p className="text-[12px] font-medium text-ink">
                  家属 {index + 1}
                </p>
                <dl className="mt-1 grid grid-cols-1 gap-x-8 sm:grid-cols-2 xl:grid-cols-3">
                  {familyMemberEntries(member).map((entry) => (
                    <div
                      key={entry.key}
                      className="min-w-0 border-b border-dashed border-sand-light/70 py-3"
                    >
                      <dt className="text-[11.5px] text-ink-faint">
                        {entry.label}
                      </dt>
                      <dd className="mt-1 whitespace-pre-wrap break-words text-[13.5px] font-medium text-ink">
                        {entry.value}
                      </dd>
                    </div>
                  ))}
                </dl>
              </div>
            ))}
          </div>
        ) : (
          <p className="mt-3 text-[12px] text-ink-faint">暂无家庭成员</p>
        )}
      </section>
    )
  );
}
